import * as React from "react";
import { AppLayout } from "../../../layouts/app";
import { useContext, useEffect, useState } from "react";
import { DataGridWithActions } from "../../../components/dataGridWithActions";
import { CrudLayout } from "../../../layouts/crud";
import { Link } from "react-router-dom";
import { Chip, Typography, Button, IconButton, Autocomplete } from "@mui/material";
import { BreadcrumbContext } from "../../../contexts/breadcrumb";
import { NotificationManager } from "react-notifications";
import { UserForm } from "./form";
import { UsersService } from "../../../services/users";
import { SnackBar } from "../../../components/snackBar";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { AuthContext } from '../../../contexts/auth';
import { CompaniesService } from "../../../services/companies";
import embryo from "../../../assets/embriao.png";
import eggs from "../../../assets/egg.png";
import chicken from "../../../assets/chick.png"
import granjas from "../../../assets/granjas.png";
import { LocalShippingOutlined, RoomOutlined } from "@mui/icons-material";


export const Users2 = () => {
    const [breadcrumbs, setBreadcrumbs] = useContext(BreadcrumbContext);
    const [users, setUsers] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const usersService = new UsersService();
    const [openSnackBar, setSnackBar] = useState(false);
    const [idUser, setUserId] = useState();
    const companiesService = new CompaniesService();
    const { companyId } = useContext(AuthContext);
    const company = companyId();
    const [companyData, setCompanyData] = useState();
    const [itemToEdit, setItemToEdit] = useState();

    useEffect(() => {
        const breadcrumbs = [
            <Link key="1" to="/">
                Home
            </Link>,
            <Typography key="2" color="text.primary">
                Usuários
            </Typography>,
        ];

        setBreadcrumbs(breadcrumbs);

        getCompanyData();
        getUsersData();
    }, []);

    const columns = [
        {
            field: 'name',
            headerName: 'Nome',
            headerAlign: 'center',
            align: 'center',
            width: 300,
            editable: false
        },
        {
            field: 'username',
            headerName: 'Usuário',
            headerAlign: 'center',
            align: 'center',
            width: 200,
            editable: false
        },
        {
            field: 'email',
            headerName: 'E-mail',
            headerAlign: 'center',
            align: 'center',
            width: 350,
            editable: false
        },
        {
            field: 'automaticReport',
            headerName: 'E-mail Automático',
            headerAlign: 'center',
            align: 'center',
            width: 170,
            editable: false,
            renderCell: ({ row }) => {
                if (row.automaticReport) {
                    return <Chip label="Habilitado" variant="outlined" color={"success"} sx={{ '& .MuiChip-label': { fontWeight: 700, fontSize: "13px" } }} />
                } else {
                    return <Chip label="Desabilitado" variant="outlined" color={'error'} sx={{ '& .MuiChip-label': { fontWeight: 700, fontSize: "13px" } }} />
                }
            }
        },
        {
            field: 'userType',
            headerName: 'Perfil',
            headerAlign: 'center',
            align: 'center',
            width: 190,
            editable: false,
            renderCell: ({ row }) => {
                if (row.userType === 'SystemAdmin') {
                    return <Chip label="Administrador" variant="outlined" color={"primary"} sx={{ '& .MuiChip-label': { fontWeight: 700, fontSize: "13px" } }} />
                } else if (row.userType === 'Administrador') {
                    return <Chip label="Administrador" variant="outlined" color={'primary'} sx={{ '& .MuiChip-label': { fontWeight: 700, fontSize: "13px" } }} />
                } else if (row.userType === 'Operador') {
                    return <Chip label="Operador" variant="outlined" sx={{ color: 'rgb(255, 140, 0)', borderColor: 'rgba(255, 140, 0, 0.74)', '& .MuiChip-label': { fontWeight: 700, fontSize: "13px" } }} />
                } else {
                    return <Chip label="Usuário" variant="outlined" sx={{ color: 'rgb(24, 76, 0)', borderColor: 'rgba(24, 76, 0, 0.74)', '& .MuiChip-label': { fontWeight: 700, fontSize: "13px" } }} />
                }
            }
        },
        {
            field: "blueprint",
            headerName: 'Planta(s)',
            headerAlign: 'center',
            align: 'center',
            width: 280,
            editable: false,
            renderCell: ({ row }) => {
                const blueprintText = Array.isArray(row.blueprint)
                    ? row.blueprint.join(", ")
                    : "";
                return (
                    <Autocomplete
                        sx={(theme) => ({
                            display: 'inline-block',
                            '& input': {
                                width: 200,
                                bgcolor: 'background.paper',
                                color: theme.palette.getContrastText(theme.palette.background.paper),
                            },
                        })}
                        inputValue={blueprintText}
                        filterOptions={(options) => options}
                        id="custom-input-demo"
                        options={row.blueprint}
                        renderOption={(props, option) => {

                            return (
                                <li {...props} style={{ fontSize: '12px', padding: '6px 12px', backgroundColor: '#f9f9f9' }}>
                                    <RoomOutlined sx={{ color: 'black', marginRight: '8px', fontSize: 15 }} />
                                    {option}
                                </li>
                            );
                        }}
                        renderInput={(params) => (
                            <div ref={params.InputProps.ref}>
                                <input type="text" {...params.inputProps} style={{ fontSize: "12px", width: "250px", height: "30px", borderRadius: "4px", borderWidth: 1.5, padding: 5 }} />
                            </div>
                        )}
                    />
                )
            }
        },
        {
            field: "vehicles",
            headerName: 'Veículo(s)',
            headerAlign: 'center',
            align: 'center',
            width: 280,
            editable: false,
            renderCell: ({ row }) => {
                const vehiclesText = Array.isArray(row.vehicles)
                    ? row.vehicles.join(", ")
                    : "";
                return (
                    <Autocomplete
                        sx={(theme) => ({
                            display: 'inline-block',
                            '& input': {
                                width: 200,
                                bgcolor: 'background.paper',
                                color: theme.palette.getContrastText(theme.palette.background.paper),
                            },
                        })}
                        inputValue={vehiclesText}
                        filterOptions={(options) => options}
                        id="custom-input-demo"
                        options={row.vehicles}
                        renderOption={(props, option) => {

                            return (
                                <li {...props} style={{ fontSize: '12px', padding: '6px 12px', backgroundColor: '#f9f9f9' }}>
                                    <LocalShippingOutlined sx={{ color: 'black', marginRight: '8px', fontSize: 15 }} />
                                    {option}
                                </li>
                            );
                        }}
                        renderInput={(params) => (
                            <div ref={params.InputProps.ref}>
                                <input type="text" {...params.inputProps} style={{ fontSize: "12px", width: "250px", height: "30px", borderRadius: "4px", borderWidth: 1.5, padding: 5 }} />
                            </div>
                        )}
                    />
                )
            }
        },
        {
            field: "typeOperation",
            headerName: 'Tipos de Operação',
            headerAlign: 'center',
            align: 'center',
            width: 280,
            editable: false,
            renderCell: ({ row }) => {
                const operationsText = Array.isArray(row.operations)
                    ? row.operations.join(", ")
                    : "";
                return (
                    <Autocomplete
                        sx={(theme) => ({
                            display: 'inline-block',
                            '& input': {
                                width: 200,
                                bgcolor: 'background.paper',
                                color: theme.palette.getContrastText(theme.palette.background.paper),
                            },
                        })}
                        inputValue={operationsText}
                        filterOptions={(options) => options}
                        id="custom-input-demo"
                        options={row.operations}
                        renderOption={(props, option) => {
                            const getImageSrc = () => {
                                if (option === 'EMBRIÕES') return embryo;
                                if (option === 'OVOS') return eggs;
                                if (option === 'PINTOS') return chicken;
                                if (option === 'GRANJAS') return granjas;
                                return null;
                            };

                            const src = getImageSrc();

                            return (
                                <li {...props} style={{ fontSize: '12px', padding: '6px 12px', backgroundColor: '#f9f9f9' }}>
                                    {src && (
                                        <img
                                            src={src}
                                            alt={option}
                                            style={{ width: '15px', height: '15px', marginRight: '8px' }}
                                        />
                                    )}
                                    {option}
                                </li>
                            );
                        }}
                        renderInput={(params) => (
                            <div ref={params.InputProps.ref}>
                                <input type="text" {...params.inputProps} style={{ fontSize: "12px", width: "250px", height: "30px", borderRadius: "4px", borderWidth: 1.5, padding: 5 }} />
                            </div>
                        )}
                    />
                )
            }
        },
    ];

    const getCompanyData = () => {
        setLoadingData(true);

        companiesService.getCompany(company).then(res => {
            setCompanyData(res.data);
            setLoadingData(false);
        }).catch(error => {
            console.error(error);
            setLoadingData(false);
        })
    }

    const getUsersData = () => {
        setLoadingData(true);
        usersService.getUsers().then(res => {
            var dict = [];
            for (var key in res.data) {
                if (res.data[key].companyId == company) {
                    dict.push(res.data[key]);
                }
            }
            setUsers(dict);
            setLoadingData(false);
            setItemToEdit();
        }).catch(error => {
            console.error(error);
            setLoadingData(false);
            setItemToEdit();
        });
    }

    const handleDelete = (id) => {
        usersService.deleteUser(id).then(res => {
            if (res.status == 200) {
                NotificationManager.success('Registro removido.', "", 3000);
            }
            getUsersData();
            setUserId(id);
            setSnackBar(true);
        }).catch(error => {
            NotificationManager.error('Erro ao remover registro.', "", 3000);
            console.error(error);
            getUsersData();
        });

    }

    const handleCloseSnackBar = () => {
        setSnackBar(false);
    }

    const handleUndoOperation = () => {
        usersService.undoUser(idUser).then((res) => {
            getUsersData();
            setSnackBar(false);
        }).catch((error) => {
            console.error(error);
        });

    }

    const handleOpenModal = (item) => {
        setItemToEdit(item);
    };

    const handleSetItemToEdit = () => {
        setItemToEdit();
    }

    const action = (
        <React.Fragment>
            <Button color="success" size="small" onClick={handleUndoOperation}  >
                DESFAZER
            </Button>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSnackBar}
            >
                <CloseRoundedIcon fontSize="small" sx={{ color: 'black' }} />
            </IconButton>
        </React.Fragment>
    );


    return (
        <>
            <AppLayout>
                <CrudLayout
                    title="Usuários"
                    formTitle='Cadastro de Usuário'
                    hasNewButton
                    form={<UserForm />}
                    itemToEdit={itemToEdit}
                    cleanItemToEdit={handleSetItemToEdit}
                    onModalClosed={getUsersData}
                    modalHeight={"88vh"}
                    children={
                        <DataGridWithActions
                            columns={columns}
                            data={users}
                            loadingData={loadingData}
                            deleteRecord={handleDelete}
                            handleOpenModal={handleOpenModal}
                            onEditOpenModal={true}
                            rowsPerPageOptions={[10]}
                            pageSize={10}
                        />
                    }
                />
            </AppLayout>

            <SnackBar open={openSnackBar} side={"left"} action={action} />
        </>
    );
}